import { useState } from "react";
import TabBox from "../../Components/Tabbox/TabBox";
import { RoleAndPermissionTables } from "../../Interfaces/roleAndPermissionsInterfaces";
import Roles from "./Roles/Roles";
import Permissions from "./Permissions";

const RolesAndPermissions = () => {
  const [activeTab, setActiveTab] = useState(
    RoleAndPermissionTables.Permission,
  );

  const tabChildren = [
    { index: RoleAndPermissionTables.Permission, title: "سطح دسترسی" },
    { index: RoleAndPermissionTables.Role, title: "نقش ها" },
  ];

  const getUI = () => {
    switch (activeTab) {
      case RoleAndPermissionTables.Permission:
        return <Permissions />;

      case RoleAndPermissionTables.Role:
        return <Roles />;
    }
  };

  return (
    <div className="flex flex-col justify-start items-start px-5 py-2 gap-5">
      <div className="w-80">
        <TabBox
          activeTab={activeTab}
          children={tabChildren}
          onChange={(_, index) => setActiveTab(index)}
        />
      </div>
      {getUI()}
    </div>
  );
};

export default RolesAndPermissions;
